import { render, staticRenderFns } from "./SliderOffersComponent.vue?vue&type=template&id=1433f74e&scoped=true&"
import script from "./SliderOffersComponent.vue?vue&type=script&lang=js&"
export * from "./SliderOffersComponent.vue?vue&type=script&lang=js&"
import style0 from "./SliderOffersComponent.vue?vue&type=style&index=0&id=1433f74e&lang=scss&scoped=true&"
import style1 from "./SliderOffersComponent.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1433f74e",
  null
  
)

export default component.exports